var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/prop-types */
import { Table, Column, HeaderCell, Cell } from 'rsuite-table';
import 'rsuite-table/dist/css/rsuite-table.css'; // or 'rsuite-table/dist/css/rsuite-table.css'
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './v1newtable.css';
var ACTIVE_ROW_CLASS = "active-row-relatory";
// eslint-disable-next-line react/prop-types
var OrderSvg = function (_a) {
    var orderDirection = _a.orderDirection, _b = _a.fill, fill = _b === void 0 ? "#41A017" : _b;
    return (_jsx("svg", __assign({ rotate: 360, fill: fill, width: '292.362px', height: '292.362px', viewBox: '0 0 292.362 292.362', className: "sort-new-relatory ".concat(orderDirection === 'asc' ? 'asc-relatory' : 'desc-relatory') }, { children: _jsx("path", { fill: fill, d: 'M286.935,69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952,0-9.233,1.807-12.85,5.424C1.807,72.998,0,77.279,0,82.228c0,4.948,1.807,9.229,5.424,12.847l127.907,127.907c3.621,3.617,7.902,5.428,12.85,5.428s9.233-1.811,12.847-5.428L286.935,95.074c3.613-3.617,5.427-7.898,5.427-12.847C292.362,77.279,290.548,72.998,286.935,69.377z' }) })));
};
var HEADER_AND_SCROLL_SIZE = 60;
var DEFAULT_SCREEN_HEIGHT = window.innerHeight >= 900 ? 555 : 400;
var SHADOW_HEADER_CLASS = "shadow-table-header";
var SHADOW_FIXED_CLASS = "shadow-fixed";
var FIXED_HEADERS = ".rs-table-cell-group-fixed-left";
var SCROLL_BOTOM_SHADOW = "scrollbar-bottom-shadow";
var HIDE_SHADOW = "hide-shadow";
var NewRelatoryTable = function (_a) {
    var defaultOrder = _a.defaultOrder, dataList = _a.dataList, translate = _a.translate, changeOrder = _a.changeOrder, shadowRef = _a.shadowRef, setShadowWidth = _a.setShadowWidth, columnsDefault = _a.columnsDefault, breakWord = _a.breakWord;
    var _b = useState([]), columnsList = _b[0], setColumns = _b[1];
    var _c = useState("asc"), sortTp = _c[0], setSortTp = _c[1];
    var _d = useState(dataList), dataListWithIds = _d[0], setDataListWithIds = _d[1];
    var _e = useState(defaultOrder), sortColumn = _e[0], setSortColumn = _e[1];
    var _f = useState(150), tableHeight = _f[0], setTableHeight = _f[1];
    var _g = useState(null), tableHeader = _g[0], setTableHeader = _g[1];
    var _h = useState(null), fixedWidth = _h[0], setFixedWidth = _h[1];
    var _j = useState(0), height = _j[0], setHeight = _j[1];
    var _k = useState(0), width = _k[0], setWidth = _k[1];
    var _l = useState(0), qtyVisibleItems = _l[0], setQtyVisibleItems = _l[1];
    var handleSortColumn = function (column, type) {
        console.log(column, type);
        changeOrder(column, type);
        setSortColumn(column);
        if (type !== undefined) {
            setSortTp(type);
        }
    };
    var checkAndAdjustShadow = function () {
        var scrollHorizontalElement = document.querySelector(".box-footer-shadow");
        setTimeout(function () {
            var hasScrollHorizontal = document.querySelector(".rs-table-scrollbar-horizontal");
            if (!hasScrollHorizontal && scrollHorizontalElement) {
                scrollHorizontalElement.style.top = '5px';
            }
            else {
                if (scrollHorizontalElement)
                    scrollHorizontalElement.style.top = '-4px';
            }
        }, 100);
    };
    useEffect(function () {
        var table = document.querySelector(".rs-table-body-row-wrapper");
        if (table) {
            var visibleItems = table.clientHeight / 40;
            setQtyVisibleItems(Math.floor(visibleItems));
        }
    }, [tableHeight]);
    useEffect(function () {
        window.addEventListener('resize', function () {
            setWidth(window.innerWidth);
            setHeight(window.innerHeight);
        });
        return function () { return window.removeEventListener("resize", function () {
            setWidth(window.innerWidth);
            setHeight(window.innerHeight);
        }); };
    }, []);
    useEffect(function () {
        checkAndAdjustShadow();
    }, [width]);
    useEffect(function () {
        if (height < 745) {
            setTableHeight(300);
        }
        else {
            var dynamicSize = dataList.length === 2 ? 120 : dataList.length * 40;
            setTableHeight(dynamicSize > DEFAULT_SCREEN_HEIGHT ? DEFAULT_SCREEN_HEIGHT + HEADER_AND_SCROLL_SIZE : dynamicSize + HEADER_AND_SCROLL_SIZE);
        }
        var table = document.querySelector(".rs-table-body-row-wrapper");
        if (table) {
            var visibleItems = table.clientHeight / 40;
            setQtyVisibleItems(Math.floor(visibleItems));
        }
    }, [height]);
    useEffect(function () {
        if (fixedWidth !== null) {
            setShadowWidth(fixedWidth.clientWidth);
        }
    }, [fixedWidth]);
    // const setScrollFixed = (scroll, number,relatoryRow ) => {
    //   scroll.classList.add("fixed")
    //   scroll.style.bottom = `${number}px`
    //   relatoryRow.classList.add("row-on-scroll-fixed")
    // }
    useEffect(function () {
        if (breakWord)
            setTableHeight(100);
    }, [breakWord]);
    useEffect(function () {
        var tableHeaderClass = document.querySelector(".rs-table-row-header");
        // const scrollHorizontalClass = document.querySelector(".box-footer-shadow")
        //  on scroll fixed, space row to avoid overlap
        // const relatoryRow = document.querySelector(".new-relatory-row")
        setTableHeader(tableHeaderClass);
        document.querySelectorAll(".relatory-table-row").forEach(function (element) { return element.classList.remove(ACTIVE_ROW_CLASS); });
        var dataWithId = dataList.map(function (item, index) { return (__assign(__assign({}, item), { uniqueId: index })); });
        setDataListWithIds(dataWithId);
        var dynamicSize = dataList.length <= 2 ? 120 : dataList.length * 40;
        setTableHeight(dynamicSize > DEFAULT_SCREEN_HEIGHT ? DEFAULT_SCREEN_HEIGHT + HEADER_AND_SCROLL_SIZE : dynamicSize + HEADER_AND_SCROLL_SIZE);
        if (window.innerHeight < 745) {
            setTableHeight(300);
        }
        var scrollHorizontalElement = document.querySelector(".box-footer-shadow");
        var scrollVerticalElement = document.querySelector(".rs-table-scrollbar-vertical");
        if (scrollVerticalElement && scrollHorizontalElement) {
            scrollHorizontalElement.classList.add(SCROLL_BOTOM_SHADOW);
            scrollHorizontalElement.classList.remove(HIDE_SHADOW);
        }
        if (!scrollVerticalElement && scrollHorizontalElement) {
            scrollHorizontalElement.classList.add(HIDE_SHADOW);
        }
        // if(scrollHorizontalClass != null) {
        //   if(dataList.length > 15 && window.innerHeight >= 900) {
        //     setScrollFixed(scrollHorizontalClass, 85, relatoryRow)
        //   }
        //   else if(dataList.length > 10  && window.innerHeight < 900) {
        //   setScrollFixed(scrollHorizontalClass, 80, relatoryRow)
        //   }
        //   else {
        //   scrollHorizontalClass.classList.remove("fixed")
        //   relatoryRow.classList.remove("row-on-scroll-fixed")
        //   scrollHorizontalClass.style.bottom = "0"
        //   }
        // }
        if (dataList.length <= 5 && scrollHorizontalElement) {
            scrollHorizontalElement.classList.add(HIDE_SHADOW);
        }
        else if (dataList.length > qtyVisibleItems && scrollHorizontalElement) {
            scrollHorizontalElement.classList.add(SCROLL_BOTOM_SHADOW);
            scrollHorizontalElement.classList.remove(HIDE_SHADOW);
        }
        else if (dataList.length === qtyVisibleItems && scrollHorizontalElement) {
            scrollHorizontalElement.classList.add(HIDE_SHADOW);
        }
        setTimeout(function () {
            var hasScrollHorizontal = document.querySelector(".rs-table-scrollbar-horizontal");
            if (!hasScrollHorizontal && scrollHorizontalElement) {
                scrollHorizontalElement.style.top = '5px';
            }
        }, 100);
    }, [dataList, breakWord]);
    var checkRenderType = function (renderLabelColor, renderBreakWord, dataKey, index, lastIndex, fullWidth) {
        if (fullWidth === void 0) { fullWidth = false; }
        if (renderLabelColor) {
            return _jsx(LabelColorCell, { rowData: undefined, dataKey: dataKey });
        }
        // Permitindo a ordenação apenas para a primeira coluna
        // const isSortable = index === 0;
        return _jsx(Cell, { className: "custom-cell-relatory ".concat(index === 0 ? 'first-cell-report' : '', " ").concat(fullWidth ? 'full-col-width' : '', " ").concat(!renderBreakWord ? 'no-break' : 'break-format', "  ").concat(index === lastIndex ? 'last-cell-report' : ''), align: 'right', height: 40, dataKey: dataKey });
    };
    var LabelColorCell = function (_a) {
        var rowData = _a.rowData, dataKey = _a.dataKey, props = __rest(_a, ["rowData", "dataKey"]);
        var statusCode = rowData.statusPriceCode;
        // 0 - WRONG PRICE; 1 - CORRECT_PRICE; 2 = WITHOUT_PRICE;
        var classColor = "";
        // eslint-disable-next-line default-case
        switch (statusCode) {
            case 0:
                classColor = "red-label";
                break;
            case 1:
                classColor = "green-label";
                break;
            case 2:
                classColor = "black-label";
                break;
            default:
                break;
        }
        return (_jsx(Cell, __assign({}, props, { children: _jsxs("div", __assign({ className: classColor }, { children: [" ", rowData[dataKey]] })) })));
    };
    var checkResizable = function (index, lastIndex, shouldBreakText) { return !(shouldBreakText || index === lastIndex); };
    useEffect(function () {
        var lastIndexSize = Object.keys(columnsDefault).length - 1;
        var getColumnsHeaders = Object.keys(columnsDefault).map(function (key, index) {
            var datakey = columnsDefault[key].type === 'labelColor' ? translate(columnsDefault[key].field) : columnsDefault[key].field;
            var shouldBreakText = columnsDefault[key].break === true;
            var shouldLabelColor = columnsDefault[key].type === 'labelColor';
            var fullWidth = columnsDefault[key].fullWidth === true;
            return _jsxs(Column, __assign({ onResize: function () {
                    var scrollElement = document.querySelector(".box-footer-shadow");
                    if (scrollElement)
                        scrollElement.scrollIntoView();
                    var fixed = document.querySelector(FIXED_HEADERS);
                    setShadowWidth(fixed === null || fixed === void 0 ? void 0 : fixed.clientWidth);
                    checkAndAdjustShadow();
                }, align: columnsDefault[key].align, width: columnsDefault[key].customWidth, sortable: !columnsDefault[key].disableOrder, fixed: columnsDefault[key].fixed, resizable: checkResizable(index, lastIndexSize, shouldBreakText) }, { children: [columnsDefault[key].type === 'wrapLine' ?
                        _jsxs(HeaderCell, __assign({ align: 'left', renderSortIcon: function () { return columnsDefault[key].field === sortColumn ? _jsx(OrderSvg, { orderDirection: sortTp }) : _jsx(OrderSvg, { fill: '#bab6bc', orderDirection: "asc" }); }, className: "break-header-padding custom-header-relatory ".concat(index === lastIndexSize ? 'last-col-report' : '', " ").concat(index === 0 ? 'first-col-report' : '', " ").concat(index + 1 === Object.keys.length ? 'unique-id' : '') }, { children: [_jsx("span", __assign({ className: 'break-header' }, { children: translate(columnsDefault[key].label) })), " "] }))
                        :
                            _jsx(HeaderCell, __assign({ align: 'left', renderSortIcon: function () { return columnsDefault[key].field === sortColumn ? _jsx(OrderSvg, { orderDirection: sortTp }) : _jsx(OrderSvg, { fill: '#bab6bc', orderDirection: "asc" }); }, className: "custom-header-relatory ".concat(index === lastIndexSize ? 'last-col-report' : '', " ").concat(index === 0 ? 'first-col-report' : '', " ").concat(index + 1 === Object.keys.length ? 'unique-id' : '') }, { children: translate(columnsDefault[key].label) })), checkRenderType(shouldLabelColor, shouldBreakText, datakey, index, lastIndexSize, fullWidth)] }), key);
        });
        setColumns(getColumnsHeaders);
    }, [sortColumn, sortTp, columnsDefault]);
    return (_jsx(Table, __assign({ wordWrap: "break-word", onScroll: function (scrollX, scrollY) {
            if (!fixedWidth) {
                var fixed = document.querySelector(FIXED_HEADERS);
                fixed != null && setFixedWidth(fixed);
            }
            if (scrollX > 0 && !shadowRef.current.classList.contains(SHADOW_FIXED_CLASS)) {
                shadowRef.current.classList.add(SHADOW_FIXED_CLASS);
            }
            else if (scrollX < 2) {
                shadowRef.current.classList.remove(SHADOW_FIXED_CLASS);
            }
            var scrollElement = document.querySelector(".rs-table-scrollbar-vertical");
            var scrollElementHandle = document.querySelector(".rs-table-scrollbar-handle");
            var scrollHorizontalElement = document.querySelector(".box-footer-shadow");
            if (scrollElement && scrollElementHandle) {
                if (scrollHorizontalElement) {
                    if (dataList.length !== qtyVisibleItems) {
                        scrollHorizontalElement.classList.add(SCROLL_BOTOM_SHADOW);
                        scrollHorizontalElement.classList.remove(HIDE_SHADOW);
                    }
                    else
                        scrollHorizontalElement.classList.add(HIDE_SHADOW);
                }
                var maxScrollSize = 40 * (dataListWithIds.length - qtyVisibleItems);
                if (scrollY > 0 && scrollY >= maxScrollSize - 20 && scrollHorizontalElement) {
                    scrollHorizontalElement.classList.add(HIDE_SHADOW);
                }
            }
            if (!scrollElement && scrollHorizontalElement) {
                scrollHorizontalElement.classList.add(HIDE_SHADOW);
            }
            if (tableHeader && scrollY >= 30 && !tableHeader.classList.contains(SHADOW_HEADER_CLASS))
                tableHeader.classList.add(SHADOW_HEADER_CLASS);
            else if (tableHeader && scrollY < 30 && tableHeader.classList.contains(SHADOW_HEADER_CLASS))
                tableHeader.classList.remove(SHADOW_HEADER_CLASS);
        }, cellBordered: false, rowHeight: 40, onRowClick: function (rowData) {
            var totalDivs = document.querySelectorAll('.relatory-table-row:not([class*="rs-table-affix-header"])');
            var hasAffixHeader = document.querySelectorAll(".rs-table-row-header");
            var rowDataId = hasAffixHeader.length > 1 ? rowData.uniqueId + 2 : rowData.uniqueId + 1;
            var divSelected = totalDivs[rowDataId];
            totalDivs.forEach(function (element, index) { return index !== rowDataId && element.classList.remove(ACTIVE_ROW_CLASS); });
            if (divSelected.classList.contains(ACTIVE_ROW_CLASS))
                divSelected.classList.remove(ACTIVE_ROW_CLASS);
            else
                divSelected.classList.add(ACTIVE_ROW_CLASS);
        }, minHeight: 150, height: tableHeight, onSortColumn: handleSortColumn, rowClassName: "relatory-table-row ", data: dataListWithIds, sortColumn: sortColumn, sortType: sortTp }, { children: columnsList.length > 0 && columnsList })));
};
NewRelatoryTable.propTypes = {
    dataList: PropTypes.array.isRequired,
    translate: PropTypes.func.isRequired,
    changeOrder: PropTypes.func,
    perPage: PropTypes.number,
    setShadowWidth: PropTypes.func,
    shadowRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ])
};
export default NewRelatoryTable;
